import React from 'react';
import { Home, Key } from 'lucide-react';
import { useSimulateur } from '../SimulateurContext';

export const Step1Transaction = () => {
  const { formData, updateFormData, goToNextStep } = useSimulateur();

  const handleSelect = (type) => {
    updateFormData('transactionType', type);
    goToNextStep();
  };

  const options = [
    {
      id: 'vente',
      icon: Home,
      title: 'Vente',
      description: 'Je vends mon bien immobilier',
      color: 'emerald',
    },
    {
      id: 'location',
      icon: Key,
      title: 'Location',
      description: 'Je mets mon bien en location',
      color: 'stone',
    },
  ];

  return (
    <div className="space-y-8">
      <div className="text-center space-y-3">
        <h2 className="text-2xl md:text-3xl font-bold text-stone-900">
          Quel est votre projet ?
        </h2>
        <p className="text-stone-600">
          Sélectionnez le type de transaction pour obtenir les diagnostics obligatoires
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto">
        {options.map((option) => {
          const Icon = option.icon;
          const isSelected = formData.transactionType === option.id;

          return (
            <button
              key={option.id}
              onClick={() => handleSelect(option.id)}
              data-testid={`transaction-${option.id}`}
              className={`
                relative p-8 rounded-2xl border-2 transition-all duration-300
                hover:shadow-lg hover:-translate-y-1 group
                ${isSelected 
                  ? 'border-emerald-500 bg-emerald-50 shadow-md' 
                  : 'border-stone-200 bg-white hover:border-emerald-300'
                }
              `}
            >
              {isSelected && (
                <div className="absolute top-4 right-4 w-6 h-6 bg-emerald-500 rounded-full flex items-center justify-center">
                  <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
              )}
              
              <div className="flex flex-col items-center text-center space-y-4">
                <div className={`
                  w-16 h-16 rounded-xl flex items-center justify-center transition-colors duration-300
                  ${isSelected 
                    ? 'bg-emerald-500 text-white' 
                    : 'bg-stone-100 text-stone-600 group-hover:bg-emerald-100 group-hover:text-emerald-600'
                  }
                `}>
                  <Icon className="w-8 h-8" />
                </div>
                
                <div>
                  <h3 className={`
                    text-xl font-semibold mb-1 transition-colors duration-300
                    ${isSelected ? 'text-emerald-700' : 'text-stone-900'}
                  `}>
                    {option.title}
                  </h3>
                  <p className="text-stone-500 text-sm">
                    {option.description}
                  </p>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
